<template>
  <div>
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex sm12 md12 lg12>
          <v-autocomplete
            :items="results"
            :label="propLabel"
            :search-input.sync="search"
            v-model="address"
            item-text="formatted_address"
            item-value="formatted_address"
            @change="completeAddress"
            :filter="customFilter"
            persistent-hint
            browser-autocomplete="off"
          >
            <template slot="nodata"></template>
          </v-autocomplete>
          <v-btn color="primary" @click="setAddress">Set</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { createNamespacedHelpers } from "vuex";
import { HTTP } from "@/http-common";
import { mapAddressFields, mapCustomerFields } from "@/store/modules/orders";
import { StringDecoder } from "string_decoder";
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const {
  mapActions: mapAddressActions,
  mapMutations: mapAddressMutations
} = createNamespacedHelpers(`orders/address`);
const { mapActions: mapCustomerActions } = createNamespacedHelpers(
  `orders/customer`
);

export default {
  name: "UtilityFindAddress",
  props: {
    usedAddresss: String,
    propLabel: String
  },
  computed: {
    ...mapAddressFields(["results"])
  },
  watch: {},
  data() {
    return {
      isDataLoading: false,
      isSaved: false,
      isSubmittedSuccessfully: false,
      isLoaded: false,
      search: null,
      address: null
    };
  },

  mounted() {
    this.$nextTick(() => {});
  },
  methods: {
    ...mapAddressActions(["getAddress", "searchAddress", "completeAddress"]),
    clearDropdown: function(e) {
      let vm = this;
      vm.results = [];
    },
    setAddress: function() {
      this.$emit("setAddress", this.address);
    },
    customFilter(item, queryText, itemText) {
      return true;
      var words = queryText.split(" ").filter(x => x.length > 0);
      var result = false;
      words.forEach(x => {
        result = result || itemText.toLowerCase().includes(x.toLowerCase());
      });
      return result;
    }
  },
  watch: {
    search(val) {
      if (val !== null) {
        if (val.length > 5) this.searchAddress(val);
      }
    }
  }
};
</script>
